export default {
    back: 'Back',
    edit: 'Edit',
    order_detail: 'Details',
    contact: 'Contact',
    change_contact: 'Change Contact',
    change_vehicle: 'Change Vehicle',
    name: 'Name',
    given_name: 'Given Name',
    family_name: 'Family Name',
    email: 'Email',
    phone_number: 'Phone Number',
    address: 'Address',
    locality: 'City',
    postal_code: 'Postal Code',
    country_code: 'Country',
    support: 'Support',
    booking_number: 'Booking Number',
    created_at: 'Created At',
    cancelled_at: 'Cancelled At',
    status: 'Status',
    financial_status: 'Financial Status',
    travel_status: 'Travel Status',
    support_status: 'Support Status',
    list_price_total: 'List Price Total',
    discount_total: 'Discount Total',
    net_price_total: 'Net Price Total',
    cancellation_fee_total: 'Cancellation Fee',
    insurance_fee_total: 'Insurance Fee',
    change_fee_total: 'Change Fee',
    manual_fee_total: 'Manual Fee',
    fee_total: 'Fee Total',
    total: 'Total',
    paid_total: 'Paid Total',
    template: 'Template',
    outstanding_amount: 'Outstanding Amount',
    discount_code: 'Discount Code',
    client_id: 'Client Id',
    refund_success: 'Refund Success',
    refund_amount: 'Refund Amount',
    refund: 'Refund',
    gateway: 'Gateway',
    type: 'Type',
    amount: 'Amount',
    currency: 'Currency',
    transactions: 'Transactions',
    date: 'Date',
    cancel_leg: 'Cancel Leg',
    cancel_leg_desc: 'Are you sure you want to cancel the selected leg?',
    cancel: 'Cancel Entire Order',
    cancel_desc: 'Are you sure you want to cancel the entire order?',
    departure: 'Departure',
    arrival: 'Arrival',
    vechile_type: 'Vechile Type',
    route: 'Route',
    failed: 'Failed',
    download_pdf: 'PDF',
    send_email: 'Send Ticket Email',
    send_success: 'Email sent.',
    incorrect_amount: 'The amount is not allowed',
    add_fee: 'Adjust Fee +/-',
    add_fee_success: 'Fee was added successfully.',
    passengers: 'Passengers',
    ticket_products: 'Ticket Products',
    fees: 'Fees',
    ticket_prices: 'Ticket Prices',
    total_prices: 'Total Prices',
    list_price: 'List Price',
    discount: 'Discount',
    net_price: 'Net Price',
    quantity: 'Quantity',
    ticket_tax_total: 'Ticket Tax Total',
    ticket_total: 'Ticket Total',
    tax_total: 'Tax Total',
    cancellation: 'Cancellation',
    insurance: 'Insurance',
    manual: 'Manual',
    selected_leg: 'Selected leg',
    add_leg_fee: 'Adjust Fee To Leg',
    add_leg_fee_success: 'Fee was added successfully.',
    calculate_cancellation_fee: 'Calculate Cancellation Fee',
    original_ticket_total: 'Original Ticket Total',
    percentage: 'Percentage Of Original Ticket Total',
    time_to_departure: 'Time Before Departure',
    registration_number: 'Registration Number',
    make: 'Make',
    model: 'Model',
    color: 'Color',
    vehicles: 'Vehicles',
    vehicle: 'Vehicle',
    gateway_transaction_id: 'Transaction id',
    gateway_order_id: 'Order id',
    locale: 'Language',
    change_vehicle_success: 'Vehicles was changed successfully',
    change_contact_success: 'Contact was changed successfully',
    update: 'Update',
    note: 'Note',
    add_note: 'Add Note',
    add_note_success: 'Note was added successfully.',
    error_phone_number: 'Phone number is not valid',
}
